export default "https://cdn-static-staging.gokick.com/assets/283628f6afcc58bd5c20cb35203f3b9e086ea5d6/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";